export default __webpack_public_path__ + "assets/images/back.167f6e.png";